import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AuthService } from '../../auth';
import { CookieService, SystemCookies } from '../../cookie';
import { AbstractLogger, LoggerFactory } from '../../diagnostics';

@Injectable({
	providedIn: 'root',
})
export class AndroidRestoreCookieGuard implements CanActivate {
	private _logger: AbstractLogger;

	constructor(
		protected readonly platform: Platform,
		protected readonly cookies: CookieService,
		protected readonly auth: AuthService,
		logger: LoggerFactory
	) {
		this._logger = logger.createLogger('AndroidRestoreCookieGuard');
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const hasCookieAuth = this.cookies.check(SystemCookies.auth1Forma);

		if (this.platform.ANDROID && !hasCookieAuth) {
			this.cookies.set(SystemCookies.auth1Forma, this.auth.token, undefined, '/');
			this._logger.forceLogInfo('auth cookie restored');
		}

		return of(true);
	}
}
